import { notificationState } from '../state/notificationState'
import {
    FETCH_FONT_TYPE_REQUEST,
    FETCH_FONT_TYPE_SUCCESS,
    FETCH_FONT_TYPE_ERROR,
    Fetch_All_Region_Data1,
    FETCH_NOTIFICATION_CATEGORY_REQUEST,
    FETCH_NOTIFICATION_CATEGORY_SUCCESS,
    FETCH_NOTIFICATION_CATEGORY_ERROR,
    FETCH_REGION_LIST_DATA,

    FETCH_NOTIFICATION_TYPE_REQUEST,
    FETCH_NOTIFICATION_TYPE_SUCCESS,
    FETCH_NOTIFICATION_TYPE_ERROR,

    FETCH_NOTIFICATION_SETTINGS_REQUEST,
    FETCH_NOTIFICATION_SETTINGS_SUCCESS,
    FETCH_NOTIFICATION_SETTINGS_ERROR,

    UPDATE_NOTIFICATION_SETTINGS_REQUEST,
    UPDATE_NOTIFICATION_SETTINGS_SUCCESS,
    UPDATE_NOTIFICATION_SETTINGS_ERROR,

    INSERT_NOTIFICATION_SETTINGS_REQUEST,
    INSERT_NOTIFICATION_SETTINGS_SUCCESS,
    INSERT_NOTIFICATION_SETTINGS_ERROR,

    DELETE_NOTIFICATION_SETTINGS_REQUEST,
    DELETE_NOTIFICATION_SETTINGS_SUCCESS,
    DELETE_NOTIFICATION_SETTINGS_ERROR
} from '../action/notificationAction'
var intialStatusCode = ''

export function notificationReducer(state = notificationState, action) {
    switch (action.type) {
        case FETCH_FONT_TYPE_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode: intialStatusCode

            })
        case FETCH_FONT_TYPE_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                fontType: action.fontType
            })
        case FETCH_FONT_TYPE_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case FETCH_NOTIFICATION_CATEGORY_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode: intialStatusCode

            })
        case FETCH_NOTIFICATION_CATEGORY_SUCCESS:

            return Object.assign({}, state, {
                isLoading: action.isLoading,
                notificationCategory: action.notificationCategory
            })
        case FETCH_NOTIFICATION_CATEGORY_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case FETCH_NOTIFICATION_TYPE_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode: intialStatusCode

            })
        case FETCH_NOTIFICATION_TYPE_SUCCESS:

            return Object.assign({}, state, {
                isLoading: action.isLoading,
                notificationType: action.notificationType
            })
        case FETCH_NOTIFICATION_TYPE_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case FETCH_REGION_LIST_DATA:
            return Object.assign({}, state, {
                regionList: action.list
            })
        case FETCH_NOTIFICATION_SETTINGS_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode: intialStatusCode

            })
        case FETCH_NOTIFICATION_SETTINGS_SUCCESS:

            return Object.assign({}, state, {
                isLoading: action.isLoading,
                notificationList: action.notificationList
            })
        case FETCH_NOTIFICATION_SETTINGS_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case INSERT_NOTIFICATION_SETTINGS_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode: intialStatusCode
            })
        case INSERT_NOTIFICATION_SETTINGS_SUCCESS:

            return Object.assign({}, state, {
                isLoading: action.isLoading,
                notificationList: action.notificationList,
                messageLabel: action.messageLabel,
                statusCode: action.statusCode


            })
        case INSERT_NOTIFICATION_SETTINGS_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case UPDATE_NOTIFICATION_SETTINGS_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode: intialStatusCode
            })
        case UPDATE_NOTIFICATION_SETTINGS_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                notificationList: action.notificationList,
                messageLabel: action.messageLabel,
                statusCode: action.statusCode
            })
        case UPDATE_NOTIFICATION_SETTINGS_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case DELETE_NOTIFICATION_SETTINGS_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode: intialStatusCode
            })
        case DELETE_NOTIFICATION_SETTINGS_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                notificationList: action.notificationList,
                messageLabel: action.errorMessage,
                statusCode: action.statusCode
            })
        case DELETE_NOTIFICATION_SETTINGS_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage,
                statusCode: intialStatusCode
            })
        case Fetch_All_Region_Data1:
            return Object.assign({}, state, {
                errorCode: action.errorCode,
                statusCode: action.statusCode,
                regionList: action.regionList
            })
        default:
            return state;
    }
}
